<template>
Update Pod's
</template>

<script>
export default {
name: "UpdatePods"
}
</script>

<style scoped>

</style>
